export default class Answer {
    constructor(model) {
        this.isCorrect = (model && model.isCorrect) || false;
        this.title = (model && model.title) || {};
    }
}
